/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TWebDeleteFavoriteRequest,
  TWebDeleteFavoriteModel,
  IMappers,
  TWebDeleteFavoriteResponse,
  TWebDeleteFavoriteResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebDeleteFavoriteModel(parameters: TWebDeleteFavoriteRequest): TWebDeleteFavoriteModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/web/delete-favorite/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebDeleteFavoriteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebDeleteFavoriteRequest;
}

export async function fetchWebDeleteFavorite<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebDeleteFavoriteOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebDeleteFavoriteResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebDeleteFavoriteModel(parameters),
    config,
  )) as FetchResponse<TWebDeleteFavoriteResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TWebDeleteFavoriteResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebDeleteFavoriteResponse>;
}
